module.exports = __webpack_public_path__ + "static/media/applicationLink2.e1625cbd.PNG";